// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FiSearch = function FiSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }]
  })(props);
};